<template>
    <div class="cliente" app>
        <Navbar/>
        
        <v-content>
            <v-overlay
                absolute
                :value="loading"
                class="text-center"
            >
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-overlay>
            <v-row align="center" justify="center" style="padding: 16px 16px; margin-top: 30px">
                <v-col cols="12" sm="11" md="10">
                    <v-alert 
                        type="error"
                        :value="alert.length > 0"
                        :dark="customization.dark">
                        {{alert}}
                    </v-alert>
                    <v-card style="overflow-x:hidden" flat :dark="customization.dark">
                        <v-form :id="`gestaoProd_form`">
                            <h1 style="padding: 16px 16px">Editar Gestão de produção e SOS</h1>
                            <v-row 
                                align="center" 
                                justify="center" 
                                style="padding: 16px 16px"
                                v-if="Object.keys(selecionado).length > 0"
                            >
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        label="Placa"
                                        name="placa"
                                        :value="selecionado['placa']"
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        label="Data"
                                        name="data"
                                        :value="selecionado['DATA_SITUACAO']"
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        label="Latitude"
                                        name="latitude"
                                        :value="selecionado['latitude']"
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        label="Longitude"
                                        name="longitude"
                                        :value="selecionado['longitude']"
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        label="Quantidade Carga"
                                        name="quantidade_carga"
                                        type="number"
                                        :value="selecionado['quantidade_carga']"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <v-text-field
                                        label="Quantidade Descarga"
                                        name="quantidade_descarga"
                                        type="number"
                                        :value="selecionado['quantidade_descarga']"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <Autocomplete
                                        :rules="requireRule"
                                        label="Carga"
                                        name="idcarga"
                                        :dark="customization.dark"
                                        url="getCarga"
                                        :needWhere="true"
                                        iddisplay="descricao"
                                        idvalue="idcarga"
                                        :value="selecionado['idcarga']"
                                        outlined >
                                    </Autocomplete>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <Autocomplete
                                        :rules="requireRule"
                                        label="Area"
                                        name="idlogponto"
                                        :dark="customization.dark"
                                        url="getLogPonto"
                                        :needWhere="true"
                                        iddisplay="nome"
                                        idvalue="idlogponto"
                                        :value="selecionado['area']"
                                        outlined >
                                    </Autocomplete>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <Autocomplete
                                        label="Motorista"
                                        name="idmotorista"
                                        :dark="customization.dark"
                                        url="getMotorista"
                                        :needWhere="true"
                                        iddisplay="nome"
                                        idvalue="idmotorista"
                                        :value="selecionado['idmotorista']"
                                        outlined >
                                    </Autocomplete>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                >
                                    <Autocomplete
                                        label="Situação"
                                        name="idsituacao"
                                        :dark="customization.dark"
                                        url="getSituacao"
                                        :needWhere="true"
                                        iddisplay="situacao"
                                        idvalue="idsituacao"
                                        :value="selecionado['idsituacao']"
                                        outlined >
                                    </Autocomplete>
                                </v-col>
                                <v-col 
                                    cols="12"
                                    sm="6"
                                    align="center"
                                    v-for="v in variaveis"
                                    :key="v.id"
                                >
                                    <v-text-field
                                        :label="v.name"
                                        v-model="v.value"
                                        type="number"
                                        outlined
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color='red'
                    style="bottom: 85px"
                    v-on="on"
                    @click="back"
                    >
                        <v-icon>mdi-cancel</v-icon>
                    </v-btn>
                </template>
                <span>Cancelar</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color='green'
                    style="bottom: 15px"
                    v-on="on"
                    @click="salvar"
                    >
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                </template>
                <span>Salvar</span>
            </v-tooltip>
        </v-content>
    </div>
</template>

<style scoped>

</style>

<script>
import Autocomplete     from '@/components/Autocomplete.vue';
import Navbar           from '@/components/Navbar.vue';
import api              from '@/plugins/apisauceHeader.js';
import router           from '@/router/index.js';

export default {
    name: 'Edit',
    components:{
        Navbar,
        Autocomplete
    },
    data(){
        return{
            id: null,
            selecionado: {},
            alert: "",
            requireRule:[
                r => (r && r.toString().length > 0) || "Essa campo é obrigatório!"
            ],
            loading: false,
            customization: {},
            nameType: "",
            cols: [],
            variaveis: []
        }
    },
    methods:{
        back(){
            router.push(`/Management`);
        },
        salvar(){
            const quantidade_carga = document.getElementsByName("quantidade_carga")[0].value != "" ? document.getElementsByName("quantidade_carga")[0].value : 0;
            const quantidade_descarga = document.getElementsByName("quantidade_descarga")[0].value != "" ? document.getElementsByName("quantidade_descarga")[0].value : 0;
            const idcarga = document.getElementsByName("idcarga")[0].value != "" ? document.getElementsByName("idcarga")[0].value : "null";
            const idlogponto = document.getElementsByName("idlogponto")[0].value != "" ? document.getElementsByName("idlogponto")[0].value : "null";
            const idsituacao = document.getElementsByName("idsituacao")[0].value != "" ? document.getElementsByName("idsituacao")[0].value : "null";
            const idmotorista = document.getElementsByName("idmotorista")[0].value != "" ? document.getElementsByName("idmotorista")[0].value : null;
            if(!idmotorista){
                this.alert = "Campo motorista precisa ser preenchido!";
                return;
            }

            this.loading = true;
            api(localStorage.getItem("token")).put(`endpoint/gestao_prod/${this.id}`,
                {
                    idlogponto,
                    idcarga,
                    quantidade_carga,
                    quantidade_descarga,
                    idsituacao,
                    idmotorista
                }
            ).then(r=>{
                if(r.ok){
                    this.applyChanges();
                }else 
                    this.alert = r.data;
                this.loading = false;
            })
        },
        applyChanges(){
            if(this.variaveis.length > 0){
                const v = this.variaveis[0];
                api(localStorage.getItem("token")).put(`endpoint/situacoes_input/${v.id}`,{
                    valor: v.value
                }).then(r=>{
                    if(r.ok){
                        this.variaveis.shift();
                        this.applyChanges();
                    }else 
                        this.alert = r.data;
                })
            }else 
                router.push(`/Management`);
        },
        get(){
            this.loading = true;
            api(localStorage.getItem("token")).get(`one/endpoint/gestao_prod/${this.id}`).then(r=>{
                if(r.ok){
                    if(r.data.length > 0){
                        this.selecionado = r.data[0];
                        this.variaveis = JSON.parse(this.selecionado['variaveis']);
                    }else
                        router.push(`/Management`);
                }
                this.loading = false;
            })
        },
        getDate(date){
            const data = new Date(date);
            const getZeroLeft = (n) =>{
                return n <= 9 ? `0${n}` : n;
            }
            return `${getZeroLeft(data.getDay())}/${getZeroLeft(data.getMonth() + 1)}/${data.getFullYear()} ${getZeroLeft(data.getHours())}:${getZeroLeft(data.getMinutes())}:${getZeroLeft(data.getSeconds())}`;
        }
    },
    mounted(){
        this.customization  = JSON.parse(localStorage.getItem("customization"));
        this.id             = this.$route.params.id;
        document.title      = `${this.customization.name} - Editar Gestão de Produção e SOS`;
        if(!localStorage.getItem("usrId")) router.push('/');
        this.get();
    }
}
</script>